import { useLocalStorage } from "@mantine/hooks"
import Authentication from "components/Molecules/Authentication"
import LocalStorage from "constants/local-storage"
import React from "react"
import { useDispatch } from "react-redux"
import { AUTH_CHANGE_CURRENT_DC } from "store/auth.redux"
import { useFilter } from "store/search-filter/search-filter.reducer"

const AuthenticationWrapper = ({
  children,
}: {
  children?: React.ReactNode
}) => {
  const dispatch = useDispatch()
  const [dc] = useLocalStorage({ key: LocalStorage.CURRENT_DC })
  const [filter, setFilter] = useFilter("dispatch")
  return (
    <Authentication
      options={{
        onCompleted({ me }) {
          const dcs = me?.distributionCentres
          if (dcs.length > 0) {
            // We should use the latest auth data in this callback than using the useDpartmentAccess hook
            if (me.user?.currentDepartment?.access?.codename === "ECOM") {
              dispatch({
                type: AUTH_CHANGE_CURRENT_DC,
                payload: dc
                  ? dcs.find(d => d.id === dc)
                  : dc === null
                  ? {
                      id: undefined,
                      name: "All DCs",
                    }
                  : dcs[0],
              })
            }

            if (
              me.permissions.find(p => /vt_limit_orders_assigned_dc/i.test(p))
            ) {
              setFilter({
                ...filter,
                distributionCentreIds: [
                  dc ? dcs.find(d => d.id === dc) : dcs[0],
                ],
              })
            }
          }
        },
      }}
    >
      {children}
    </Authentication>
  )
}

export default AuthenticationWrapper
